import { render, staticRenderFns } from "./BasicSearch.vue?vue&type=template&id=a85fe278&scoped=true&"
import script from "./BasicSearch.vue?vue&type=script&lang=js&"
export * from "./BasicSearch.vue?vue&type=script&lang=js&"
import style0 from "./BasicSearch.vue?vue&type=style&index=0&id=a85fe278&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85fe278",
  null
  
)

export default component.exports